import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveEditorMode, toggleActivePrompt } from '../../../../store/slices/pageSlice';
import s from './PostEditorTabs.module.css';

const tabs = ['Visual', 'Captions', 'Review'];

const PostEditorTabs = ({
    activeEditorMode,
    saveImage,
}: {
    activeEditorMode: string;
    saveImage: () => void;
}) => {
    const dispatch = useDispatch();
    const tabsRef = useRef<(HTMLButtonElement | null)[]>([]);
    const indicatorRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const activeIndex = tabs.findIndex((tab) => tab === activeEditorMode);
        const activeTab = tabsRef.current[activeIndex];
        const indicator = indicatorRef.current;

        if (activeTab && indicator) {
            const tabRect = activeTab.getBoundingClientRect();
            const containerRect = activeTab.parentElement?.getBoundingClientRect();

            if (containerRect) {
                const offsetLeft = tabRect.left - containerRect.left;
                const width = tabRect.width;

                indicator.style.transform = `translateX(${offsetLeft}px)`;
                indicator.style.width = `${width}px`;
            }
        }
    }, [activeEditorMode]);

    return (
        <div className={s.tabsContainer}>
            <div className={s.tabsRow}>
                <div className={s.tabsWrapper}>
                    <div className={s.activeIndicator} ref={indicatorRef}></div>
                    {tabs.map((tab, index) => {
                        return (
                            <button
                                key={tab}
                                ref={(el) => (tabsRef.current[index] = el)}
                                className={
                                    activeEditorMode === tab
                                        ? `${s.tabButton} ${s.tabButtonActive}`
                                        : s.tabButton
                                }
                                onClick={async () => {
                                    if (activeEditorMode === 'Visual' && tab !== 'Visual') {
                                        await saveImage();
                                    }

                                    if (tab === 'Review') {
                                        dispatch(toggleActivePrompt('preview_post'));
                                        dispatch(setActiveEditorMode('Review'));
                                    } else {
                                        dispatch(setActiveEditorMode(tab));
                                    }
                                }}
                            >
                                {tab}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PostEditorTabs;
